import React from 'react';
import { GHG_INVENTORY_SECTION } from './homePageConstants';

export const GhgInventorySection: React.FC = () => (
  <section
    id="ghg-inventory"
    className="home-section home-section--muted home-ghg-inventory"
    aria-labelledby="ghg-inventory-heading"
  >
    <div className="home-section__container">
      <header className="home-section__header">
        <h2 id="ghg-inventory-heading" className="home-section__title">
          {GHG_INVENTORY_SECTION.title}
        </h2>
      </header>
      <ul className="home-ghg-inventory__grid">
        {GHG_INVENTORY_SECTION.items.map((item) => (
          <li key={item} className="home-ghg-inventory__item">
            {item}
          </li>
        ))}
      </ul>
    </div>
  </section>
);
